/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Leaflet=====================
import Leaflet from 'leaflet';
// =================Components leaflet===================
import {
  MapContainer, Marker, Popup, TileLayer,
} from 'react-leaflet';

// ===================Dependances================
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

// ==================Icons=========================
import iconUrl from '../../../assets/images/circlemaponepoint.png';

// ===============Actions===========================
import { toggleBackgroundImage } from '../../../actions/site';

// ===============Components===========================
import UseMap from './UseMap';

function MapOnePoint({
  marker_long_name, location, date_from, date_to = '', network,
}) {
  // ==================HOOK=========================
  const dispatch = useDispatch();
  const buttonImage = useSelector((state) => state.site.map.miniatureBackground);
  const mapURL = useSelector((state) => state.site.map.mapURL);
  // ================Handler=======================
  function handleBackgroundImage() {
    dispatch(toggleBackgroundImage());
  }

  // ================classnames=====================

  const miniatureBackground = classnames('mapbuttonid', { 'mapbuttonid--road': buttonImage });

  // defining standard properties of an icon
  const newicon = new Leaflet.Icon({
    iconUrl,
    iconSize: [20, 20],
    iconAnchor: [20, 20],
    popupAnchor: [-10, -20],
    className: network.name,
  });

  return (
    <MapContainer
      center={[location.coordinates.lat, location.coordinates.lon]}
      zoom={4}
      minZoom={2}
      style={{ width: 'auto', minHeight: '434px', height: '100%' }}
      gestureHandling
      scrollWheelZoom={false}
    >
      <button className={`${miniatureBackground}`} aria-label="background_image" type="submit" onClick={handleBackgroundImage} />
      <TileLayer
        url={mapURL}
        attribution="zoom: CTRL+SCROLL"
      />
      <Marker
        key={marker_long_name}
        icon={newicon}
        position={[
          location.coordinates.lat,
          location.coordinates.lon,
        ]}
      >
        <Popup key={marker_long_name}>
          <div className="popup-single-station">
            <div className="station-1">
              <ul>
                <li><strong>Marker:</strong> {marker_long_name}</li>
                <li><strong>Lat:</strong> {location.coordinates.lat}</li>
                <li><strong>Lon:</strong> {location.coordinates.lon}</li>
                <li><strong>Alt:</strong> {location.coordinates.altitude}</li>
                <li><strong>Install date:</strong> {date_from}</li>
                <li><strong>End date:</strong> {date_to}</li>
                <li><strong>Country:</strong> {location.city.name}</li>
                <li><strong>Network:</strong> {network.name}</li>
              </ul>
            </div>
          </div>
        </Popup>
      </Marker>
      <UseMap />
    </MapContainer>
  );
}

MapOnePoint.propTypes = {
  marker_long_name: PropTypes.string.isRequired,
  location: PropTypes.shape({
    coordinates: PropTypes.shape({
      altitude: PropTypes.number.isRequired,
      lat: PropTypes.number.isRequired,
      lon: PropTypes.number.isRequired,
    }).isRequired,
    city: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  date_from: PropTypes.string.isRequired,
  date_to: PropTypes.string,
  network: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,

};

export default MapOnePoint;
